import React, {Component} from 'react';
import html2canvas from 'html2canvas';
import Modal from 'react-responsive-modal';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareSquare } from '@fortawesome/free-solid-svg-icons';
// import {FB, FacebookApiException} from 'fb';
import Api from '../../utils/api';

import './ShareModule.css';

library.add(faShareSquare);

class ShareModule extends Component {
    constructor() {
        super();

        this.toggleShareButtons = this.toggleShareButtons.bind(this);
        this.convertToCanvasFB = this.convertToCanvasFB.bind(this);
        this.convertToCanvasInsta = this.convertToCanvasInsta.bind(this);
        this.facebookShare = this.facebookShare.bind(this);
        this.instaShare = this.instaShare.bind(this);
        this.emailShare = this.emailShare.bind(this);
        this.convertToCanvasEmail = this.convertToCanvasEmail.bind(this);

        this.imgSrc = '';

        this.state = {
            showShareButtons: false,
            imageURL: '',
            openModal: false
        }
    }

    toggleShareButtons() {
        this.setState({ showShareButtons: !this.state.showShareButtons });
    }

    facebookShare(e) {
      e.preventDefault();
      this.generateDummyDiv();
      this.props.toggleShareCard(this.convertToCanvasFB);
    }

    instaShare(e) {
        e.preventDefault();
        this.generateDummyDiv();
        this.props.toggleShareCard(this.convertToCanvasInsta);
    }

    emailShare(e) {
        e.preventDefault();
        this.generateDummyDiv();
        this.props.toggleShareCard(this.convertToCanvasEmail);
    }

    convertToCanvasFB() {
        let element = document.getElementById("dummy-div");
        html2canvas(element)
        .then((canvas) => {
            let filename = Api.getUUID()  + '.jpg';
            let reader = new FileReader();
            canvas.toBlob((blob) => {
                reader.readAsDataURL(blob);

                reader.onloadend = (evt) => {
                    this.imgSrc = reader.result;
                    Api.s3ImageUpload(this.imgSrc, filename, 'image/jpeg', process.env.REACT_APP_S3_BUCKET_SKIN_PROFILE);
                    // TODO: optimize
                    let imageUrlPrefix = 'https://resources.helloava.co/skin-profile/';
                    if (process.env.REACT_APP_ENV === 'dev') {
                        imageUrlPrefix = 'https://dev-resources.helloava.co/skin-profile/';
                    }
                    const imageURL = imageUrlPrefix + filename;
                    this.setState({
                        imageURL: imageURL
                    }, function() {
                        this.props.toggleShareCard(function() {return;});
                    });

                    if (imageURL !== '') {
                        window.FB.ui({
                            method: 'feed',
                            picture: imageURL
                        }, function(response){});
                        this.props.hideDummyDiv();
                    }
                }
            });

        })
        .catch((err) => {
            alert('Error saving card.')
        });
    }

    convertToCanvasInsta() {
        let element = document.getElementById("dummy-div");
        html2canvas(element)
        .then((canvas) => {
            let dataURL = canvas.toDataURL('image/jpeg', 1);
            this.setState({
                imageURL: dataURL
            }, function() {
                this.props.toggleShareCard(function() {return;});
            });
            if (this.state.imageURL !== '') {
                this.openModal();
                this.props.hideDummyDiv();
            }
        })
        .catch((err) => {
            alert('Error saving card.')
        });
    }

    

    convertToCanvasEmail() {
        let element = document.getElementById("dummy-div");
        html2canvas(element)
        .then((canvas) => {
            let filename = Api.getUUID()  + '.jpg';
            let reader = new FileReader();
            canvas.toBlob((blob) => {
                reader.readAsDataURL(blob);

                reader.onloadend = (evt) => {
                    this.imgSrc = reader.result;
                    Api.s3ImageUpload(this.imgSrc, filename, 'image/jpeg', process.env.REACT_APP_S3_BUCKET_SKIN_PROFILE);
                    // TODO: optimize
                    let imageUrlPrefix = 'https://resources.helloava.co/skin-profile/';
                    if (process.env.REACT_APP_ENV === 'dev') {
                        imageUrlPrefix = 'https://dev-resources.helloava.co/skin-profile/';
                    }

                    const imageURL = imageUrlPrefix + filename;

                    this.setState({
                        imageURL: imageURL
                    }, function() {
                        this.props.toggleShareCard(function() {return;});
                    });

                    if (this.state.imageURL !== '') {

                        const emailSubject = "My Skin Profile from HelloAva";
                        const emailBody = "View my skin profile here! Click on the following link: " + this.state.imageURL; 
                        window.location.href = 'mailto:&subject=' + emailSubject + '&body=' + emailBody;
                        this.props.hideDummyDiv();
                        
                    }
                }
            });

        })
        .catch((err) => {
            alert('Error saving card.')
        });
    }



    generateDummyDiv() {
        let dummyDivContent = document.createElement("div");
        dummyDivContent.setAttribute("id", "dummy-div-container");
    }

    openModal() {
        this.setState({ openModal: true });
    }

    closeModal() {
        this.setState({ openModal: false });
    }


    render() {
        return(
            <div id="share-module" className="share-module">
                <button onClick={this.toggleShareButtons} >
                    <FontAwesomeIcon icon="share-square" />
                    <span>Share My Skin Profile</span>
                </button>
                {
                    this.state.showShareButtons ?
                    <div className="share-buttons">
                        <div className="share-button" ><img alt="Facebook" onClick={ this.facebookShare }src="/images/onboarding/sharemodule/fb.png" /></div>
                        <div className="share-button"><img alt="Download" onClick={ this.instaShare } src="/images/onboarding/sharemodule/download.svg" /></div>
                        <div className="share-button"><img alt="Email" onClick={ this.instaShare } src="/images/onboarding/sharemodule/email.png" /></div>
                    </div> :
                    null
                }

                <Modal open={ this.state.openModal } onClose={ this.closeModal.bind(this) } little={ true }
                    classNames={{ overlay: 'ha-overlay', modal: 'ha-modal' }}>
                    <div className="share-popup-modal">
                        <div className="share-popup-body">Share this image with your friends! Click on the button to download.</div>
                        <button><a href={this.state.imageURL} download>Download</a></button>
                        <img alt="Your Skin Profile" src={this.state.imageURL} />
                    </div>
                </Modal>
            </div>
        );
    }
}
export default ShareModule;



// WEBPACK FOOTER //
// ./src/components/onboarding/ShareModule.js